import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { SeoServiceService } from 'src/app/services/seo-service.service';

@Component({
  selector: 'app-find-the-perfect-ifp-size-for-your-campus',
  templateUrl: './find-the-perfect-ifp-size-for-your-campus.component.html',
  styleUrls: ['./find-the-perfect-ifp-size-for-your-campus.component.scss']
})
export class FindThePerfectIfpSizeForYourCampusComponent implements OnInit {

  constructor(
    private titleService: Title,
    private metaService: Meta,
    private seoService: SeoServiceService
  ) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
    this.titleService.setTitle('Find the Perfect IFP Size for Your Campus | VIRSA Interactive Flat Panels');
    this.metaService.updateTag({ name: 'description', content: 'Find the perfect Interactive Flat Panel size for your campus. Compare 75”, 86”, 98”, and 105” VIRSA IFPs for classrooms, lecture halls, seminar rooms, and smart campuses.' });
    this.metaService.updateTag({ name: 'keywords', content: 'find the perfect IFP size, best interactive flat panel for campus, interactive flat panel sizes for schools, 75 inch interactive flat panel, 86 inch smart board, VIRSA interactive flat panels' });
  }

  scrollToElement(elementId: string): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

}
